import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { API_CONSTANT } from './services/api.constant';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'app';
  defaultLang = 'en';
  navbarActive = false;

  constructor(private httpClient: HttpClient, private translateService: TranslateService) {
    if (localStorage.getItem('lang')) {
      this.defaultLang = localStorage.getItem('lang');
    }
    translateService.setDefaultLang('en');
    translateService.use(this.defaultLang);
    httpClient.get(API_CONSTANT.feature_flag).subscribe(
      (response: any) => {
        environment.enabledCustomerRequest = response.enabled_customer_request;
        this.navbarActive = true;
      }
    )
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/app.component.ts